// src/pages/programs/CreateProgram.jsx

import React from "react";
import { useNavigate } from "react-router-dom";

import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditProgram from "../../components/programs/FormAddEditProgram";

const CreateProgram = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/programs");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditProgram
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateProgram;
